import * as RadixTooltip from '@radix-ui/react-tooltip';
import React from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export function Tooltip({ content, children, side = 'top' }: TooltipProps) {
  return (
    <RadixTooltip.Provider delayDuration={300}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>
          {children}
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            sideOffset={6}
            className="
              z-50 max-w-[250px] px-3 py-2
              rounded text-xs leading-relaxed shadow-none
              animate-in fade-in-0 zoom-in-95
            "
            style={{ backgroundColor: 'var(--surface-container-high)', border: '1px solid var(--outline-variant)', color: 'var(--text-secondary)' }}
          >
            {content}
            <RadixTooltip.Arrow style={{ fill: 'var(--surface-container-high)' }} />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}

export function InfoIcon() {
  return (
    <svg 
      width="14" 
      height="14" 
      viewBox="0 0 14 14" 
      fill="none" 
      className="inline-block ml-1 cursor-help align-middle"
      style={{ color: 'var(--text-tertiary)' }}
    >
      <circle cx="7" cy="7" r="6.5" stroke="currentColor"/>
      <path 
        d="M7 6v4M7 4.5v.5" 
        stroke="currentColor" 
        strokeWidth="1.2" 
        strokeLinecap="round"
      />
    </svg>
  );
}

// Usage pattern:
// <Tooltip content="LRS = Locally Redundant Storage. Three copies within one datacenter.">
//   <span>LRS <InfoIcon /></span>
// </Tooltip>
